import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { ShopifyEditorLinkDto } from '@/Domain/api/Shopify/dto/ShopifyEditorLink.dto';
import { ShopifyRedirectDto } from '@/Domain/api/Shopify/dto/ShopifyRedirect.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class ShopifyApi {
  static getEditorLink = (): Promise<ShopifyEditorLinkDto> =>
    httpClient.get(Endpoint.shopify.editorLink).then(ApiMapper.toResponseData);

  // The scenario-less chooser has no interceptor-provided scenario-id, so pass it explicitly.
  static startOauth = (shopUrl: string, scenarioId: string): Promise<ShopifyRedirectDto> =>
    httpClient
      .get(Endpoint.shopify.oauth, {
        params: { shop_url: shopUrl },
        headers: { 'scenario-id': scenarioId },
      })
      .then(ApiMapper.toResponseData);
}
